// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NewMeetingPopup__form-a7bb9e {
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: auto;
}

.NewMeetingPopup__textField-c28eae {
  padding: 24px 24px 4px 24px;
}

.NewMeetingPopup__menu-item-c9295a.NewMeetingPopup__switch-ca21ca {
  padding: 12px 24px;
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/Popups/NewMeetingPopup/NewMeetingPopup.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,OAAA;EACA,cAAA;AACF;;AAEA;EACE,2BAAA;AACF;;AAEA;EACE,kBAAA;AACF","sourcesContent":[".form {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  overflow: auto;\n}\n\n.textField {\n  padding: 24px 24px 4px 24px;\n}\n\n.menu-item.switch {\n  padding: 12px 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"form": `NewMeetingPopup__form-a7bb9e`,
	"textField": `NewMeetingPopup__textField-c28eae`,
	"menu-item": `NewMeetingPopup__menu-item-c9295a`,
	"menuItem": `NewMeetingPopup__menu-item-c9295a`,
	"switch": `NewMeetingPopup__switch-ca21ca`
};
module.exports = ___CSS_LOADER_EXPORT___;
